import { useState } from "react";

export const useCompletedMessages = () => {
  const [completedMessages, setCompletedMessages] = useState<{
    [id: string]: boolean;
  }>({});

  const markAsCompleted = (id: string) => {
    setCompletedMessages((prev) => ({
      ...prev,
      [id]: true,
    }));
  };

  const isCompleted = (id: string): boolean => {
    return !!completedMessages[id];
  };

  return { markAsCompleted, isCompleted };
};
